var React = require('react');

function EyeOpenInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.205 4.743c-1.118.644-2.127 1.712-3.036 3.228C3.98 10.698 5.92 12 8 12c2.081 0 4.02-1.302 5.83-4.029C12.219 5.282 10.29 4 8 4a5.75 5.75 0 0 0-1 .086 1.5 1.5 0 0 0-1.796.657zm-.073 1.374a1.5 1.5 0 1 0 1.985-1.985 3 3 0 1 1-1.984 1.984zM.124 7.518C2.12 3.89 4.764 2 8 2c3.235 0 5.88 1.89 7.876 5.518a1 1 0 0 1-.026 1.009C13.618 12.127 10.996 14 8 14 5.004 14 2.382 12.127.15 8.527a1 1 0 0 1-.026-1.009z","fill":"currentColor"}));
}

EyeOpenInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = EyeOpenInline;

EyeOpenInline.default = EyeOpenInline;
